export default __webpack_public_path__ + "static/media/switch_icon.9acd62a1.svg";